import React from "react";
import "./Feedback.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// Feedback data extracted from the provided HTML
const feedbacks = [
  {
    text: "This free darshan was not just an opportunity—it was a blessing that filled my heart with peace and my soul with faith. I am incredibly thankful to those who made this possible.",
    name: "Narsimha",
    city: "Nagole, Hyd",
    logo: "https://sascct.org/wp-content/uploads/2024/06/330-Sopanapadayatra-1.webp", // Image URL
  },
  {
    text: "Experiencing the divine darshan of Lord Venkateswara at Tirumala was a lifelong dream for me. Thanks to the generous opportunity for free darshan.",
    name: "Rajani",
    city: "Nallakunta",
    logo: "https://sascct.org/wp-content/uploads/2024/12/DSC_6366-copy.webp", // Image URL
  },
  {
    text: "Thank you to everyone who made this dream a reality for me. May the Lord’s blessings be upon you always.",
    name: "Shanthamma",
    city: "Moosapet",
    logo: "https://sascct.org/wp-content/uploads/2025/02/195-Sopanapadayathra-02.webp", // Image URL
  },
];

const FeedbackSection = () => {
  return (
    <section className="feedback-section">
      <div className="feedback-overlay">
        <div className="feedback-container">
          <h2 className="feedback-title">Devotee Experiences & Blessings</h2>
          <p className="feedback-intro">
            Hear from those who have felt the divine presence and blessings at our sacred temple.
          </p>

          {/* Swiper Component with Breakpoints */}
<Swiper
  modules={[Autoplay, Navigation, Pagination]}
  spaceBetween={30}
  slidesPerView={3}
  loop={true}
  centeredSlides={false}  // ❌ Remove centeredSlides for correct loop motion
  autoplay={{
    delay: 1000,
    disableOnInteraction: false,
  }}
  navigation={true}  // ✅ Let Swiper create default arrows automatically
  pagination={{ clickable: true }}
  breakpoints={{
    0: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 },
  }}
  className="feedback-swiper"
>
  {feedbacks.map((feedback, index) => (
    <SwiperSlide key={index} className="feedback-card-slide">
      <div className="feedback-card">
        <p className="feedback-text">"{feedback.text}"</p>
        <div className="feedback-user">
          <img
            src={feedback.logo}
            alt={feedback.name}
            className="feedback-user-logo"
          />
          <div className="feedback-user-info">
            <h4 className="feedback-user-name">{feedback.name}</h4>
            <span className="feedback-user-city">{feedback.city}</span>
          </div>
        </div>
      </div>
    </SwiperSlide>
  ))}
</Swiper>


        </div>
      </div>
    </section>
  );
};

export default FeedbackSection;
